import { __rest, __assign } from '../../../../../_virtual/_tslib.js';
import { InputWrapper, Input as Input$1, IconWrapper } from './Input.styles.js';
import React from 'react';

function Input(_a) {
  var icon = _a.icon,
      iconOnClick = _a.iconOnClick,
      flexGrow = _a.flexGrow,
      isValid = _a.isValid,
      fontSize = _a.fontSize,
      _b = _a.inputSize,
      inputSize = _b === void 0 ? 'medium' : _b,
      inputRef = _a.inputRef,
      props = __rest(_a, ["icon", "iconOnClick", "flexGrow", "isValid", "fontSize", "inputSize", "inputRef"]);

  return icon ? React.createElement(InputWrapper, {
    flexGrow: flexGrow
  }, React.createElement(Input$1, __assign({
    iconExists: Boolean(icon),
    flexGrow: flexGrow,
    fontSize: fontSize,
    isValid: isValid,
    inputSize: inputSize,
    ref: inputRef
  }, props)), React.createElement(IconWrapper, {
    onClick: iconOnClick
  }, icon)) : React.createElement(Input$1, __assign({
    flexGrow: flexGrow,
    fontSize: fontSize,
    isValid: isValid,
    inputSize: inputSize,
    ref: inputRef
  }, props));
}

export { Input };